import React from 'react';
import * as Icon from './icons';
import * as styles from './ActionButton.module.scss';
import classNames from 'classnames';
import { upperFirst } from 'lodash';

export default function ActionButton({
  className,
  icon,
  href,
  children,
  ...restProps
}) {
  const Tag = href ? 'a' : 'button';
  const IconComponent = Icon[upperFirst(icon)] ?? null;

  return !children ? null : (
    <Tag
      href={href}
      className={classNames(styles.wrapper, className)}
      {...restProps}
    >
      {IconComponent && (
        <IconComponent className={classNames(styles.icon, icon)} />
      )}
      {children}
    </Tag>
  );
}
